import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import "./BookingLineupCards.css";

const FeeSummaryPanel = ({ footerRow, title, currencySymbol, actOwnerBalance }) => {
    if (!footerRow) {
        return null;
    }

    return (
        <div className="lineup-fee-summary">
            <Card elevation={1}>
                <div className="lineup-fee-summary-header">
                    <Typography variant="subtitle1" className="lineup-fee-summary-title">
                        {title || "Fee Summary"}
                    </Typography>
                </div>
                
                <CardContent className="lineup-fee-summary-content">
                    <div className="lineup-fee-summary-row">
                        <span className="lineup-fee-summary-label">Total Player Fees</span>
                        <span className="lineup-fee-summary-value">{footerRow.fee}</span>
                    </div>
                    <div className="lineup-fee-summary-row">
                        <span className="lineup-fee-summary-label">Total Super</span>
                        <span className="lineup-fee-summary-value">{footerRow.superFee}</span>
                    </div>
                    
                    {actOwnerBalance !== undefined && (
                        <div className="lineup-fee-summary-row act-owner">
                            <span className="lineup-fee-summary-label">
                                <span>Act Owner Balance</span>
                                <span className="lineup-fee-summary-sublabel">Gig Fee - Player Fees</span>
                            </span>
                            <span className="lineup-fee-summary-value">{currencySymbol || "$"} {actOwnerBalance}</span>
                        </div>
                    )}
                    
                    <div className="lineup-fee-summary-row lineup-fee-summary-total">
                        <span className="lineup-fee-summary-label">Total Invoice</span>
                        <span className="lineup-fee-summary-value">{footerRow.invoiceAmount}</span>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default FeeSummaryPanel;
